export default __webpack_public_path__ + "static/media/open-positions-pop-up-2k.1f9b93ae.jpg";